import i18n from "@/i18n"; // 引入 I18n 套件
export const main = {
    install(Vue, option) {
        i18n.init(option.config).then(oI18n => {
            // **************** 報名原因
            const applyReasons = ['football', 'health', 'teamwork', 'english', 'others'];
            const enrollReasonOptions = applyReasons.map(key => {
                return { value: key, text: oI18n.t(`applyReasonOptions.${key}`) };
            });
            Vue.prototype.$enrollReasonOptions = enrollReasonOptions;

            // **************** 學校類型
            const schoolTypes = ['public_school', 'international_school', 'private_school'];
            const schoolTypeOptions = schoolTypes.map(key => {
                return { value: key, text: oI18n.t(`schoolTypeOptions.${key}`) };
            });
            Vue.prototype.$schoolTypeOptions = schoolTypeOptions;

            // **************** Nation
            const studentNations = ['hongkong', 'china', 'foreign'];
            const nationOptions = studentNations.map(key => {
                return { value: key, text: oI18n.t(`studentNationOptions.${key}`) };
            });
            Vue.prototype.$nationOptions = nationOptions;
        })
    }
}

export const excludeMenuList = ['online-course', 'website-setting', 'enquiry'];
export const gradeList = ['toddler', 'kindergarten', 'primary', 'EC'];